export enum MyFavouritesDtoProp {
  SavedScreens = 'savedScreens',
  SavedViews = 'savedViews',
  Scheduled = 'upcoming',
  Priced = 'priced',
  Filled = 'filled',
  Others = 'others',
  News = 'news',
}
